import { FooterItems } from "../hooks/FooterItems"

export const ProjectFooter = () => {
    return (
        <footer className="pb-6 bg-gray-100 text-gray-800 dark:bg-gray-800">

            <FooterItems />

        </footer>
    )
}